export const STREAMS_REMOVE_SUCCESS = 'STREAMS_REMOVE_SUCCESS';
export const STREAMS_REMOVE_FAILURE = 'STREAMS_REMOVE_FAILURE';
export const STREAMS_REMOVE_REQUEST = 'STREAMS_REMOVE_REQUEST';
